import {isEqual, omit, orderBy} from 'lodash'
import {EventDialogModel} from 'module/EventDialog/type/EventDialogType'
import {CFMember} from 'module/CustomField/type/CFType'
import {SisName} from 'util/SisName'

function filterAndSortCF(cf?: CFMember[]) {
	if (!cf) return []
	return orderBy(cf.filter(x => typeof x.version === 'number' || x.data || x.data === 0), ['pos', 'dstField'])
}

export function isEqualEventDialogModel(model1?: Partial<EventDialogModel> | null, model2?: Partial<EventDialogModel> | null) {
	if (!model1 && !model2) return true;
	else if (model1 && !model2 || !model1 && model2 || model1?.sisName !== model2?.sisName) return false;
	const sisName = model1?.sisName || model2?.sisName
	if (sisName === SisName.Persurl || sisName === SisName.Booking) {
		const m1 = omit(model1, 'cf')
		const m2 = omit(model2, 'cf')
		if (!isEqual(m1, m2)) return false
		const cf1 = model1?.cf || []
		const cf2 = model2?.cf || []
		return isEqual(filterAndSortCF(cf1), filterAndSortCF(cf2))
	} else {
		return isEqual(model1, model2)
	}
}